import { PropsWithChildren } from 'react'

import { createStyles } from 'antd-style'

import { FormLayout } from '@eastcoal/formily/components/FormLayout'

const useStyles = createStyles(({ token }) => ({
  box: {
    width: '100%',
    paddingTop: token.controlHeightSM,
    border: '1px solid ',
    borderColor: token.colorBorder
  }
}))

export const FormItemBlock = ({ children }: PropsWithChildren) => {
  const { styles } = useStyles()
  return (
    <FormLayout labelWidth={120} wrapperWidth={420}>
      <section className={styles.box}>{children}</section>
    </FormLayout>
  )
}
